import React, { useEffect } from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Layout from "../../ui/Layout";
import NavMain from "../../app/NavMain";
import ScrollablePage from "../../ui/ScrollablePage";
import Paper from "../../ui/Paper";
import PaperTitle, { TitleText } from "../../ui/PaperTitle";
import { useDispatch, useSelector } from "react-redux";
import { Header, Overview } from "../../ui/PageHeader";
import GenerateSchedule from "./GenerateSchedule";
import {
	fetchPlaylists,
	selectPlaylistsByContext,
	selectPlaylistByIds,
} from "./slice";
import ErrorMsg from "../../ui/ErrorMsg";
import PlaylistsTable from "./PlaylistsTable";
import { useInterval } from "../timing/use-interval";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  > * {
    width: 100%;
  }
`;
const Card = styled.div`
  padding-right: 1rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

/* ScheduleDashboard lets the user start, and displays progress, for generating
 * and deploying a schedule to the astrosite based on all active priority lists. */
const ScheduleDashboard = () => {
	// To pass along to Generate Tasks sidebar
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const priority_lists = urlParams.get("priority_lists");
	const selectedPriorityListIDs = priority_lists
		? priority_lists.split(",")
		: undefined;

	return (
		<Layout>
			<NavMain key="nav-left" />
			<Helmet>
				<title>Generate schedule - Astrosite</title>
			</Helmet>
			<ScrollablePage>
				<Header>
					<Overview>
						<h1>Generate schedule</h1>
						<p>
							Generate a schedule from selected priority lists and send it to an
							Astrosite
						</p>
					</Overview>
				</Header>
				<Container>
					<Card>
						<RecentTasks />
						{/*<Paper>*/}
						{/*  <PaperTitle>*/}
						{/*    <TitleText>Pre-deployment Checklist</TitleText>*/}
						{/*  </PaperTitle>*/}
						{/*  <p>*/}
						{/*    It&apos;s the operator&apos;s responsibility to check the*/}
						{/*    following items before starting deployment:*/}
						{/*  </p>*/}
						{/*  <ol>*/}
						{/*    <li>*/}
						{/*      Nobody else is currently actively using any of the telescopes,*/}
						{/*      as this will reconfigure them immediately to exclusively*/}
						{/*      collect data according to the{" "}*/}
						{/*      <Link to="/priorities?sort_by=priority&sort_order=DESC&active=true">*/}
						{/*        active priority lists*/}
						{/*      </Link>*/}
						{/*    </li>*/}
						{/*    <li>*/}
						{/*      The weather conditions are suitable to deploy the Astrosite*/}
						{/*    </li>*/}
						{/*  </ol>*/}
						{/*</Paper>*/}
					</Card>

					<Card>
						<GenerateSchedule
							selectedPriorityListIDs={selectedPriorityListIDs}
						/>
					</Card>
				</Container>
			</ScrollablePage>
		</Layout>
	);
};

const RecentTasks = () => {
	const dispatch = useDispatch();
	// we get any matching actions
	const taskMatches = useSelector((state) =>
		selectPlaylistsByContext(state, "root"),
	);
	// We get the full objects from the ids that match
	const tasks = useSelector((state) =>
		selectPlaylistByIds(state, taskMatches?.ids || []),
	);

	// Fetch once immediately
	useEffect(() => {
		dispatch(
			fetchPlaylists({
				filter: {},
				page: { offset: 0, limit: 10 },
				context: ["root"],
			}),
		);
	}, []);

	// Poll at an interval
	useInterval(
		() => {
			dispatch(
				fetchPlaylists({
					filter: {},
					page: { offset: 0, limit: 10 },
					context: ["root"],
				}),
			);
		},
		10000,
		false,
	);

	return (
		<Paper>
			<PaperTitle>
				<TitleText loadingState={taskMatches?._loadStatus || "idle"}>
					Recent schedules
				</TitleText>
			</PaperTitle>
			{taskMatches?._loadStatus === "rejected" && (
				<ErrorMsg msg={"Problem loading past schedules"} showIcon={true} />
			)}
			<PlaylistsTable playlists={tasks} hideFilters={true} />

			<footer className="actions">
				{tasks.length > 0 &&
					tasks.length !== taskMatches?.page?.total_count && (
						<div>
							Showing {tasks.length} of{" "}
							<Link to="/playlists">{taskMatches?.page?.total_count}</Link>
						</div>
					)}
			</footer>
		</Paper>
	);
};

export default ScheduleDashboard;
